export default __webpack_public_path__ + "static/media/home_hero_section.90ebc95d.svg";